import { EqlFieldName, UNIFIED_FIELD } from '@modules/common/constants';
import {
  EqlField,
  EqlFieldValueType,
  IntegrationChannelType,
  ObjectType,
} from 'generated/graphql';
import { capitalize } from 'lodash';

interface getGroupLabelFromEqlFieldOptions {
  eqlField: EqlField;
  shouldRemoveFileUploadPrefix: boolean;
}

export const getGroupLabelFromEqlField = ({
  eqlField,
  shouldRemoveFileUploadPrefix,
}: getGroupLabelFromEqlFieldOptions): string => {
  switch (eqlField.field) {
    case EqlFieldName.Entity:
    case EqlFieldName.Reason:
    case EqlFieldName.UserSentiment:
    case EqlFieldName.EntitySentiment:
    case EqlFieldName.Category:
    case EqlFieldName.Summary:
    case EqlFieldName.Search:
    case EqlFieldName.FeedbackRecords:
    case EqlFieldName.Source:
    case EqlFieldName.Language:
    case 'FEEDBACK':
      return 'Enterpret';
    default:
      if (eqlField.objectType && eqlField.objectType !== ObjectType.Feedback) {
        return capitalize(eqlField.objectType);
      }

      if (eqlField?.detail?.metadata?.source === 'Common') {
        return UNIFIED_FIELD;
      }

      if (eqlField.valueType === EqlFieldValueType.None) {
        return 'Custom Filters';
      }

      const sourceName = (
        (shouldRemoveFileUploadPrefix
          ? eqlField?.detail?.metadata?.source?.replaceAll(
              `${IntegrationChannelType.FileUpload}-`,
              '',
            )
          : eqlField?.detail?.metadata?.source) ?? ''
      ).trim();

      return sourceName;
  }
};
